import React from "react";
import styled from "styled-components";
import get from "lodash/get";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useIntl, navigate } from "gatsby-plugin-intl";
import { graphql } from "gatsby";

const StyledWrapper = styled.div`
  width: 100%;
  position: relative;
  ${(props) =>
    props.link &&
    `
        &:hover {
            cursor: pointer;
            opacity: 0.9;
        }    
    `}
`;

const StyledImg = styled(GatsbyImage)`
  object-fit: cover;
`;

const StyledContentWrapper = styled.div``;

const StyledTitle = styled.div``;

const StyledDescription = styled.div`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
`;

const ImageHeroModal = ({ imageDescription }) => {
  const intl = useIntl();
  const handleClick = () => {
    if (imageDescription.link) {
      navigate(imageDescription.link);
    }
  };
  return (
    <StyledWrapper link={imageDescription.link} onClick={() => handleClick()}>
      {imageDescription.asset && (
        <GatsbyImage image={getImage(imageDescription.asset.imageFile)} />
      )}
      <StyledTitle>
        {get(imageDescription, `title[${intl.locale}]`, "")}
      </StyledTitle>
      <StyledDescription>
        {get(imageDescription, `description[${intl.locale}]`, "")}
      </StyledDescription>
    </StyledWrapper>
  );
};

export default ImageHeroModal;

export const query = graphql`
  fragment imageHeroModal on STRAPI_ComponentBaseImageHeroModal {
    __typename
    id
    imageDescription {
      asset {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      title {
        en
        es
        it
      }
      link
      description {
        en
        es
        it
      }
    }
  }
`;
